var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pa-0 ma-0"},[_c('v-col',{staticClass:"pa-0 ma-0 mt-1",attrs:{"cols":"1"}},[_c('v-icon',{staticClass:"check-mark",attrs:{"size":"20"}},[_vm._v(" $vuetify.icons.statusOk ")])],1),_c('v-col',{staticClass:"pa-0"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }